import { search } from "../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/empresa`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findPayableSituations(companyDocument) {
  const url = `${path}/${companyDocument}/financeiro/situacao/pagar?perPage=50`;

  return search(decodeURIComponent(url), "GET", headers);
}

export async function findReceiptSituations(companyDocument) {
  const url = `${path}/${companyDocument}/financeiro/situacao/receber?perPage=50`;

  return search(decodeURIComponent(url), "GET", headers);
}
